import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Formik, FormikHelpers } from 'formik';
import { Form as BForm, Button, Col, Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import { Account } from '../App';
import '../css/modals.css';
import { TextInput } from './common';
import { normalizeText, phoneRegExp } from './common/helpers';

interface props {
  showModal: boolean;
  closeModal: () => void;
  done: () => void;
  setAccount: (account: Account) => void;
}

export default function CreateAccount({
  showModal = false,
  closeModal,
  done,
  setAccount,
}: props) {
  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        show={showModal}
        onHide={closeModal}
        contentClassName="ec-modal-content"
      >
        <Modal.Header className="ec-modal-header" closeButton>
          <Modal.Title className="ec-modal-title">Create Account</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            phoneNumber: '',
            positionTitle: '',
          }}
          validationSchema={Yup.object({
            firstName: Yup.string().trim().max(100).required('Required'),
            lastName: Yup.string().trim().max(100).required('Required'),
            email: Yup.string()
              .trim()
              .email('Invalid email address')
              .max(254)
              .required('Required'),
            password: Yup.string().required('Required'),
            phoneNumber: Yup.string()
              .trim()
              .max(30)
              .matches(phoneRegExp, 'Phone number is not valid'),
            positionTitle: Yup.string().trim().max(150),
          })}
          onSubmit={async (
            values: Account,
            { setSubmitting }: FormikHelpers<Account>
          ) => {
            setAccount({
              firstName: normalizeText(values.firstName) || '',
              lastName: normalizeText(values.lastName) || '',
              email: normalizeText(values.email) || '',
              password: values.password,
              phoneNumber: normalizeText(values.phoneNumber) || '',
              positionTitle: normalizeText(values.positionTitle) || '',
            });
            setSubmitting(false);
            done();
          }}
        >
          {({ errors, isSubmitting }) => (
            <Form>
              <Modal.Body>
                <BForm.Row>
                  <BForm.Group
                    as={Col}
                    controlId="formBasicFirstName"
                    className="mb-0"
                  >
                    <TextInput
                      label="First name"
                      name="firstName"
                      type="text"
                      autoComplete="given-name"
                    />
                  </BForm.Group>
                  <BForm.Group
                    as={Col}
                    controlId="formBasicLastName"
                    className="mb-0"
                  >
                    <TextInput
                      label="Last name"
                      name="lastName"
                      type="text"
                      autoComplete="family-name"
                    />
                  </BForm.Group>
                </BForm.Row>
                <BForm.Group controlId="formBasicEmail">
                  <TextInput
                    label="Email"
                    name="email"
                    type="text"
                    inputMode="email"
                    autoComplete="email"
                  />
                </BForm.Group>
                <BForm.Group controlId="formBasicPassword">
                  <TextInput
                    label="Password"
                    name="password"
                    type="password"
                    autoComplete="new-password"
                  />
                </BForm.Group>
                <BForm.Group controlId="formBasicPhoneNumber">
                  <TextInput
                    label="Phone number"
                    name="phoneNumber"
                    type="tel"
                    autoComplete="tel"
                  />
                </BForm.Group>
                <BForm.Group controlId="formBasicPosition">
                  <TextInput
                    label="Position"
                    name="positionTitle"
                    type="text"
                    autoComplete="organization-title"
                  />
                </BForm.Group>
              </Modal.Body>
              <Modal.Footer className="ec-modal-footer">
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                  className="ec-modal-create-account-submit"
                >
                  Next
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
